export const filterEmptyNodes = function (nodes: Array<Node>): Array<Node> {
    return nodes.filter((node) => {
        if (node.nodeName === "#text") {
            return node.textContent.trim() !== "";
        }

        return true;
    });
};
